import { DocumentReference } from "@firebase/firestore";
import { isEmail } from "react-multi-email";
import { getUser } from ".";
import { SearchResult } from "../../components/pack/PackShareSection";
import { ContactList, getContactList } from "./contacts";

export const parseSharedEntryFromFirestore = async (sharedEntry: string | DocumentReference): Promise<SearchResult> => {
  if (typeof sharedEntry === "string") {
    const textUser: string = sharedEntry as string;
    return isEmail(textUser)
      ? { type: "email", value: textUser }
      : { type: "user", value: { id: textUser, ...(await getUser(textUser)) } };
  } else {
    const listRef: DocumentReference<ContactList> = sharedEntry as DocumentReference<ContactList>;
    const list = await getContactList(listRef);
    if (!list) return null
    return { type: "list", value: list };
  }
}